//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      typeList: ['sign', 'apply'],
    }
  },
  props: {
    returnData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    showScore: {
      type: Boolean,
      default: false
    },
    answer: {
      type: Object,
      default() {
        return null;
      }
    },
  },
  methods: {
    // 下载标题和副标题图片
		downTitleImg(id) {
			return this.ssdpRequestDtgw1({
        code: 'survey_download',
        headers: {
          's-crc-tpl-code': 'EMAP_FILE_DOWN',
          'content-type':'application/json',
        },
        params: {
          fileId: id
        },
        responseType: "blob",
        isUpload: false,
      })
      .then((res) => {
        const blobUrl = URL.createObjectURL(res.data);
        return Promise.resolve(blobUrl)
      });
		},
    // 获取副标题html下的所有图片，然后获取id下载到本地在替换地址
    replaceImg() {
      const titleDom = document.querySelector("#titleImg");
      const descriptionImgDom = document.querySelector("#descriptionImg");
      const imgs = [...titleDom.querySelectorAll("img"), ...descriptionImgDom.querySelectorAll("img")];
      console.log("需要下载的图片", imgs);
      for (const img of imgs) {
        ((el) => {
          let id;
          id = el.src.split("?fileId=")[1];
          if (id) {
            this.downTitleImg(id)
              .then(url => {
                this.$nextTick(() => {
                  el.src = url;
                  console.log("下载图片成功", url);
                })
              });
          }
        })(img);
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.replaceImg()
    }, 2000)
  }
}
